// Copyright (c) 2019 Deere & Company

import { FormattedMessage } from 'react-intl';
import { PropTypes } from 'prop-types';
import RadioButton from './radio-button';
import React from 'react';


const RadioButtonList = props => (
    <ul className="radio-fixed-container">
        {props.label && (
            <h4>
                <FormattedMessage id={props.label} />
            </h4>
        )}
        {
            props.items.map( ( item, index ) => (
                <RadioButton
                    changed={props.changed}
                    id={`${index}`}
                    isSelected={item.isSelected}
                    label={item.label}
                    value={item.label}
                    key={`rb-${item.label}`}
                />

            ) )
        }
    </ul>
);
RadioButtonList.displayName = 'RadioButtonList';
RadioButtonList.propTypes = {
    items: PropTypes.array.isRequired,
    label: PropTypes.string.isRequired,
    // onItemsUpdate: PropTypes.func.isRequired,
    changed: PropTypes.func.isRequired,
};


export default RadioButtonList;
